import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { PopupService } from 'src/app/core/services/popup/popup.service';
import { FormService } from 'src/app/shared/services/form/form.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-add-user',
    templateUrl: './add-user.component.html',
    styleUrl: './add-user.component.sass',
    standalone: false
})

export class AddUserComponent {

  addUserForm: FormGroup;
  submittedWrongCredentials: boolean = false;

  constructor(private popupService: PopupService, private router: Router, private dialogRef: MatDialogRef<AddUserComponent>,
              private fb: FormBuilder, private formService: FormService) {
    this.addUserForm = fb.group({
      'firstName': ['', Validators.required],
      'lastName': ['', Validators.required],
      'email': ['', Validators.compose([Validators.required, Validators.email])],
    });
  }

  addUser() {
    this.submittedWrongCredentials= false;
    if(!environment.production) {
      console.log(this.addUserForm.valid);
    }
    if(this.addUserForm.valid) {
      if(!environment.production) {
        console.log(this.addUserForm.value);
      }
      this.dialogRef.close(this.addUserForm.value);
      return;
    } else {
      this.submittedWrongCredentials = true;
    }
  }

  closePopup() {
    this.popupService.closeCurrentDialog();
  }

  getErrorMessage(controlName: string) {
    return this.addUserForm.get(controlName)?.touched || this.submittedWrongCredentials
    ? this.formService.getErrorMessageForFormControl( controlName, this.addUserForm) : '';
  }

}